module.exports = __webpack_public_path__ + "310941cda283bb7dd9833a535dc9b595.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2020-01-21/whats-new.html
// module id = 2240
// module chunks = 0